import React from 'react';
import { stripHtml } from 'string-strip-html';
import ReactHtmlParser from 'react-html-parser';
import DialogNotification from '../../components/DialogNotification/DialogNotification';
import { TestCaseStatus, TextCaseType } from '../../dto/TestCaseDTO';

import styles from './ChatbotTesting.module.css';

export default function ChatbotTestingDetail(props) {
  if (props.testCase.status === TestCaseStatus.IN_PROGRESS
    || props.testCase.status === TestCaseStatus.NOT_EXECUTED
    || props.testCase.status === TestCaseStatus.ERROR) {
    props.setShowDetail(false);
    return <></>;
  }

  let result = '';
  let expectedResult = '';

  props.testCase.expectedResult.forEach((part) => {
    expectedResult = `${expectedResult}<span class="text-info">(${part.type})</span><br/>`;
    expectedResult = `${expectedResult}${stripHtml(part.text || '').result}<br/>`;

    if (part.type === TextCaseType.OPTIONS) {
      expectedResult = `${expectedResult}<ul>`;
      part.options.forEach((option) => {
        expectedResult = `${expectedResult}<li>${stripHtml(option || '').result}</li>`;
      });
      expectedResult = `${expectedResult}</ul>`;
    }
    expectedResult = `${expectedResult}`;
  });

  props.testCase.result.forEach((part) => {
    result = `${result}<span class="text-info">(${TextCaseType[part.type]})</span><br/>`;

    if (TextCaseType[part.type] === TextCaseType.TEXT) {
      result = `${result}${stripHtml(part.text || '').result}<br/>`;
    } else if (TextCaseType[part.type] === TextCaseType.OPTIONS) {
      result = `${result}${stripHtml(part.title || '').result}<br/><ul>`;
      part.options.forEach((option) => {
        result = `${result}<li>${stripHtml(option.label || '').result}</li>`;
      });
      result = `${result}</ul>`;
    }
    result = `${result}`;
  });

  return (
    <DialogNotification
      color="info"
      title="Detalhes da Execução do Teste"
      classes={styles.TestDetailModal}
      content={(
        <div className={styles.TestDetailContent}>

          <div>
            <span>Mensagem Enviada:</span>
            <span>{props.testCase.message}</span>
          </div>

          <div>
            <span>Mensagem Recebida:</span>
            <span>{ReactHtmlParser(result)}</span>
          </div>

          <div>
            <span>Mensagem Recebida Esperada:</span>
            <span>{ReactHtmlParser(expectedResult)}</span>
          </div>

          <div>
            <span>Resultado:</span>
            <span>{props.testCase.status}</span>
          </div>

        </div>
      )}
      okAction={() => props.setShowDetail(false)}
      scrimAction={() => {}}
    />
  );
}
